// eslint-disable-next-line no-shadow
export enum ScreenSize {
  SM = 320,
  MD = 768,
  LG = 1360,
}

export const breakpoints = {
  smallOnly: `(max-width: ${ScreenSize.MD / 16}em)`,
  extraSmall: `(max-width: ${ScreenSize.SM / 16}em)`,
  small: `(min-width: ${ScreenSize.SM / 16}em)`,
  medium: `(min-width: ${ScreenSize.MD / 16}em)`,
  large: `(min-width: ${ScreenSize.LG / 16}em)`,
  ltLarge: `(max-width: ${ScreenSize.LG / 16}em)`,
}

export const mq = Object.keys(breakpoints).reduce(
  (obj, bp) => ({
    ...obj,
    [bp]: `@media ${breakpoints[bp as keyof typeof breakpoints]}`,
  }),
  {} as typeof breakpoints
)
